export const aaaYellow30 = '#FFC425';
export const csaaBlack = '#0B1421';
export const csaaBlue05 = '#D3E6FA';
export const csaaBlueInfo = '#F2F9FF';
export const csaaBorder = '#E3E5EE';
export const csaaDark = '#373B49';
export const csaaDarkTransparent = 'rgba(11, 20, 33, 0.1)';
export const csaaGray = '#F7F8FC';
export const csaaLight = '#878C9D';
export const csaaLightBorder = '#676C7D';
export const csaaLightGreen = '#F2FFF7';
export const csaaLightRed = '#FFE6E6';
export const csaaMid = '#4D5160';
export const csaaNeutral = '#E3E5EE';
export const csaaNeutralBackground = '#F7F8FC';
export const csaaNeutralBorder = '#ABAFBF';
export const csaaRed10 = '#FEB3B3';
export const csaaGreen10 = '#B3F9CE';
export const csaaSpectrumBlue50 = '#115DC4';
export const csaaSpectrumBlue50Hover = '#115DC41A';
export const csaaSpectrumGreen50 = '#00844D';
export const csaaSpectrumRed50 = '#D52B1E';
export const csaaWhite = '#FFFFFF';
export const csaaOverlayBlack = '#0B14211A';
export const csaaInteractiveBlue = '#00338D';
export const spectrumBlue50WithOpacity50 = '#115DC480';
export const blackWithOpacity50 = '#00000061';
export const blueInteractiveButtonHover = '#0044AC';
export const blackInteractiveButtonHover = '#0B14210D';
export const redInteractiveButtonHover = '#D52B1E0D';
export const unselectedToggleHover = '#373B4914';
export const textFieldHoverBackground = '#0B142114';

const colors = {
  aaaYellow30,
  csaaBlack,
  csaaBlue05,
  csaaBlueInfo,
  csaaBorder,
  csaaDark,
  csaaDarkTransparent,
  csaaGray,
  csaaLight,
  csaaLightBorder,
  csaaLightGreen,
  csaaLightRed,
  csaaMid,
  csaaNeutral,
  csaaNeutralBackground,
  csaaNeutralBorder,
  csaaRed10,
  csaaSpectrumBlue50,
  csaaSpectrumBlue50Hover,
  csaaSpectrumGreen50,
  csaaSpectrumRed50,
  csaaWhite,
  csaaGreen10,
  csaaOverlayBlack,
  csaaInteractiveBlue,
  spectrumBlue50WithOpacity50,
  blackWithOpacity50,
  blueInteractiveButtonHover,
  blackInteractiveButtonHover,
  redInteractiveButtonHover,
  unselectedToggleHover,
  textFieldHoverBackground,
};

export default colors;
